var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VuePhoneNumberInput',_vm._b({attrs:{"options":_vm.options,"value":_vm.value,"color":"#D1D5DB"},on:{"update":_vm.handleChange}},'VuePhoneNumberInput',_vm.context.attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }